import {Log} from '@aboutyou/mlm';
import {ABTests} from './types';
import {FlagValueString} from '../types';

const EXPERIMENTS_SEPARATOR = '|';
const EXPERIMENT_VARIANT_SEPARATOR = '=';
const ARRAY_WITH_EXPERIMENT_AND_VARIANT = 2;

export const getAbTestGroups = (experimentsCookieValue?: string) => {
  if (!experimentsCookieValue || experimentsCookieValue.length === 0) {
    return [];
  }

  const experiments = experimentsCookieValue.split(EXPERIMENTS_SEPARATOR);

  const abTestExperiments: ABTests = [];
  experiments.forEach(experiment => {
    const expAndVariant = experiment.split(EXPERIMENT_VARIANT_SEPARATOR);

    if (expAndVariant.length === ARRAY_WITH_EXPERIMENT_AND_VARIANT) {
      abTestExperiments.push({
        key: expAndVariant[0] as string,
        group: expAndVariant[1] as FlagValueString,
      });
    }
  });

  if (!abTestExperiments.length) {
    Log.warn(
      '@aboutyou/feature-flags',
      `ab test value obtained invalid cookie data=[${experimentsCookieValue}], can't extract experiment and value`,
    );
  }

  return abTestExperiments;
};
